class HomepageAdTagBuilder {
    constructor() {
        this.adZoneSite = this.getSite();
        this.adZone = this.buildAdZone();
        this.adUrl = this.buildAdURL();
    }

    buildAdURL() {
        // var keyVals = this._determineCustomParam();
        // var keyValString = '';
        // _.each(keyVals, function (value, key) {
        //     keyValString += `%26${key}=${value}`;
        // });

        let tag = 'https://pubads.g.doubleclick.net/gampad/ads?' +
        'sz=640x360' +
        '&impl=s' +
        '&gdfp_req=1' +
        '&env=vp' +
        '&output=vast' +
        '&unviewed_position_start=1' +
        '&vad_type=linear' +
        '&vpos=preroll' +
        //'&url=%5Breferrer_url%5D' +
        '&correlator=' + Date.now() +
        //'&iu=' + this.params.zone + '/preroll' +
        '&iu=' + this.adZone +
        //'&location=item-location__' +
        //'&camera=item-camera' +
        // Custom Params:
        // TESTING:
        // '&cust_params=cms%3Ddfp_video_test';
        // PRODUCTION:
        '&cust_params=' + //video_tags%3D' + window.DFPtags +
        '%26vport=' + this.getViewport() +
        '%26video_id=__item-mediaid__'; //+
        // keyValString;

        return tag;
    }

    buildAdZone() {
        let adZoneArray = ['', '4160', this.adZoneSite, 'studios', 'homepage', 'preroll_homepage'];
        return adZoneArray.join('/');
    }

    getSite() {
        switch (true) {
        case window.location.href.match(/fastcompany/):
            return 'mv.fc';
        case window.location.href.match(/fastcodesign/):
            return 'mv.fcdesign';
        case window.location.href.match(/fastcoexist/):
            return 'mv.fcexist';
        case window.location.href.match(/fastcocreate/):
            return 'mv.fccreate';
        default:
            return 'mv.fc';
        }
    }

    getViewport() {
        let w = window.innerWidth;

        if (w > 1023) {
            return 'l';
        }

        if (w < 640) {
            return 's';
        }

        return 'm';
    }

    // getParams() {
    //     var params = {};
    //     var query = this.video_url.search.substring(1);
    //     var vars = query.split('&');
    //     for (var i = 0; i < vars.length; i++) {
    //         var pair = vars[i].split('=');
    //         params[pair[0]] = decodeURIComponent(pair[1]);
    //     }
    //     return params;
    // }

    // _determineCustomParam() {
    //     var params = {},
    //         model = window.bootstrap_obj,
    //         type = model.type,
    //         kind = model.kind,
    //         topic = model.topic,
    //         supertag = model.supertag,
    //         tags = model.tags,
    //         author = model.author,
    //         keywords = model.keywords;

    //     if (kind === undefined) {
    //         params.c_type = type;
    //     } else {
    //         params.c_type = kind || '';
    //     }

    //     if (typeof Krux !== "undefined") {
    //         params.ksg = Krux.segments || [];
    //         params.kuid = Krux.user || '';
    //     }

    //     params.scroll = window.bootstrap_obj.infiniteScrollPageNum || 0;

    //     params.chn = [];
    //     if (topic && topic.slug) {
    //         params.chn.push(topic.slug);
    //     }
    //     if (supertag && supertag.slug) {
    //         params.chn.push(supertag.slug);
    //     }

    //     //TAGS
    //     if (tags) {
    //         var tagslugs = [];
    //         $.each(tags, function (index, tag) {
    //             if (tag.slug) {
    //                 tagslugs.push(tag.slug);
    //             }
    //         });

    //         if (tagslugs.length) {
    //             params.tags = tagslugs;
    //         }
    //     }

    //     if (keywords && keywords.socialtags) {

    //         if (!params.tags) {
    //             params.tags = [];
    //         }

    //         $.each(keywords.socialtags, function (index, keyword) {
    //             params.tags.push(keyword);
    //         });

    //         params.tags = $.unique(params.tags);
    //     }

    //     if (params.tags) {
    //         params.tags = $.unique(params.tags);
    //     }

    //     params.slide = (kind === 'slideshow') ? 1 : 0;
    //     // if (util.get('fastcache')) {
    //     //     params.login = 'yes'; //(util.get('fastcache') ? 1 : 0);
    //     // }

    //     //VIDEO
    //     params.video = (kind === 'video' || kind === 'watch') ? 'yes' : 'no';

    //     // If kind is watch set global object _refreshOnVideoChange in order to enable listening to messages
    //     if (kind === "watch") {
    //         window._refreshOnVideoChange = true;
    //     }

    //     //AUTHOR
    //     params.aut = ((author && author.name) ? String(author.name).toLowerCase().replace(/\s+/g, '') : '');

    //     //Switched page level nsfw key/value to adzone
    //     // params.nsfw = this.ads.nsfw ? 'yes' : 'no';

    //     // Key val identifier for ad request coming into redesign
    //     params.abgroup = '1';

    //     return params;
    // }

    // parses our playlistcount from a url
    // getPlaylistCount(url) {
    //     var matchedID = url.match(/&playlistCount=(.*)/);
    //     if (matchedID && matchedID[1]) {
    //         return matchedID[1];
    //     }
    //     return '';
    // }

    // Parses video ID from URL
    // getVideoID(url) {
    //     var matchedID = url.match(/embed\/(.*)\?/)[1];
    //     if (matchedID) {
    //         return matchedID;
    //     }
    //     return '';
    // }
}

export default new HomepageAdTagBuilder();
